import { memo } from "react";

import { isJsonBlob } from "utils/json";
import type { EntityAttributeChange } from "types/generated";

import { CHANGE_COLOR, CHANGE_PREFIX } from "../constants";
import { extractAttributeValue } from "../helpers";
import RunCodeChangesJsonRow from "../JsonRow";
import RunCodeChangesPrefix from "../Prefix";
import RunCodeChangesValues from "../Values";
import styles from "./styles.module.css";

type RunCodeChangesRowProps = {
  name: string;
  item: EntityAttributeChange;
};

const RunCodeChangesRow = memo(({ name, item }: RunCodeChangesRowProps) => {
  const { type } = item.changeForPhase.metadata;
  const prefix = CHANGE_PREFIX[type] ?? "\u00a0";
  const color = CHANGE_COLOR[type];

  const before = extractAttributeValue(item.changeForPhase.before);
  const after = extractAttributeValue(item.changeForPhase.after);
  const { afterUnknown } = item.changeForPhase;

  const beforeString = before?.type === "string" ? String(before.value) : undefined;
  const afterString = after?.type === "string" ? String(after.value) : undefined;

  if ((beforeString && isJsonBlob(beforeString)) || (afterString && isJsonBlob(afterString))) {
    return (
      <RunCodeChangesJsonRow
        name={name}
        prefix={prefix}
        color={color}
        beforeJson={beforeString}
        afterJson={afterString}
        afterUnknown={afterUnknown}
      />
    );
  }

  return (
    <>
      <span />
      <RunCodeChangesPrefix prefix={prefix} color={color} />
      <span className={styles.name}>{name ? `${name}:` : ""}</span>
      <span className={styles.values}>
        <RunCodeChangesValues
          type={type}
          before={before}
          after={after}
          afterUnknown={afterUnknown}
        />
      </span>
    </>
  );
});

RunCodeChangesRow.displayName = "RunCodeChangesRow";

export default RunCodeChangesRow;
